module.exports = __webpack_public_path__ + "static/media/buy_interview_1.ffd9bac8.jpg";